var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeslimat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 386.62 491.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:#e95066;}.cls-4{fill:#e2002e;}.cls-5{clip-path:url(#clippath-1);}.cls-6{clip-path:url(#clippath-4);}.cls-7{clip-path:url(#clippath-3);}.cls-8{clip-path:url(#clippath-2);}.cls-9{clip-path:url(#clippath-7);}.cls-10{clip-path:url(#clippath-8);}.cls-11{clip-path:url(#clippath-6);}.cls-12{clip-path:url(#clippath-5);}.cls-13{clip-path:url(#clippath-9);}.cls-14{clip-path:url(#clippath-10);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -64.38,
    width: 451,
    height: 491.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -64.38,
    width: 451,
    height: 491.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -64.38,
    width: 451,
    height: 491.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -64.38,
    width: 451,
    height: 491.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -64.38,
    width: 451,
    height: 491.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -64.38,
    width: 451,
    height: 491.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -64.38,
    width: 451,
    height: 491.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -64.38,
    width: 451,
    height: 491.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -64.38,
    width: 451,
    height: 491.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -64.38,
    width: 451,
    height: 491.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -64.38,
    width: 451,
    height: 491.52
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m237.03,18.21v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m248.59,18.21v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m260.15,18.21v-1.29h8.5v1.29h-8.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m205.41,36.38v-2.26h2.38v2.26h-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m216.02,32.66v-1.77h4.3v1.77h-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m227.97,29.48l-.46-2.26v-2.5h1.67v2.5l-.46,2.26h-.75Zm2.74,0l-.46-2.26v-2.5h1.67v2.5l-.46,2.26h-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m239.14,32.66v-1.77h4.3v1.77h-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m248.05,32.83v-1.51c.17-.19.39-.39.66-.6.27-.2.59-.38.95-.52.36-.14.75-.21,1.16-.21.36,0,.71.06,1.04.17.33.11.65.24.97.39.32.15.64.28.98.39.33.11.69.17,1.06.17.41,0,.79-.07,1.15-.21s.68-.31.96-.52.5-.4.66-.6v1.51c-.16.19-.38.39-.66.6-.28.2-.6.38-.96.52-.36.14-.74.21-1.15.21-.36,0-.71-.06-1.04-.17s-.65-.24-.97-.39-.64-.28-.98-.39-.69-.17-1.06-.17c-.41,0-.79.07-1.16.21-.36.14-.68.31-.95.52-.27.2-.49.4-.66.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m262.26,32.66v-1.77h4.3v1.77h-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m274.21,29.48l-.46-2.26v-2.5h1.67v2.5l-.46,2.26h-.75Zm2.74,0l-.46-2.26v-2.5h1.67v2.5l-.46,2.26h-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m285.38,32.66v-1.77h4.3v1.77h-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m297.89,36.38v-2.26h2.38v2.26h-2.38Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m190.18,59.69l8.18-14.57h1.55l-8.16,14.57h-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m205.41,56.78v-2.26h2.38v2.26h-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m216.02,53.06v-1.77h4.3v1.77h-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m227.97,49.88l-.46-2.26v-2.5h1.67v2.5l-.46,2.26h-.75Zm2.74,0l-.46-2.26v-2.5h1.67v2.5l-.46,2.26h-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m239.14,53.06v-1.77h4.3v1.77h-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m251.65,56.78v-2.26h2.38v2.26h-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m262.26,53.06v-1.77h4.3v1.77h-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m274.21,49.88l-.46-2.26v-2.5h1.67v2.5l-.46,2.26h-.75Zm2.74,0l-.46-2.26v-2.5h1.67v2.5l-.46,2.26h-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m285.38,53.06v-1.77h4.3v1.77h-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m297.89,56.78v-2.26h2.38v2.26h-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m313.94,59.69l-8.16-14.57h1.55l8.18,14.57h-1.56Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m194.34,80.58v-15.64h1.39v15.64h-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m205.9,80.58v-15.64h1.39v15.64h-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m219.32,79.85c-.87-.99-1.54-2.1-2.01-3.33-.46-1.23-.7-2.52-.7-3.84s.23-2.59.7-3.83c.46-1.23,1.13-2.35,2.01-3.33h1.09c-.4.65-.76,1.37-1.08,2.16-.32.79-.58,1.61-.76,2.46s-.28,1.69-.28,2.53.09,1.67.28,2.53c.19.86.44,1.69.76,2.48.32.79.68,1.51,1.09,2.16h-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m230.88,79.85c-.87-.99-1.54-2.1-2.01-3.33-.46-1.23-.7-2.52-.7-3.84s.23-2.59.7-3.83c.46-1.23,1.13-2.35,2.01-3.33h1.09c-.4.65-.76,1.37-1.08,2.16-.32.79-.58,1.61-.77,2.46s-.28,1.69-.28,2.53.09,1.67.28,2.53c.19.86.44,1.69.76,2.48.32.79.68,1.51,1.09,2.16h-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m241.28,77.35c-.86,0-1.6-.19-2.22-.56-.62-.37-1.09-.89-1.42-1.56-.33-.66-.49-1.41-.49-2.25v-.29c0-.86.16-1.62.49-2.28.33-.66.8-1.17,1.42-1.54.62-.37,1.35-.55,2.2-.55s1.62.19,2.24.56,1.09.89,1.42,1.55c.33.66.49,1.41.49,2.26v.29c0,.86-.16,1.62-.49,2.28-.33.66-.8,1.17-1.42,1.54s-1.36.55-2.22.55Zm0-1.34c.6,0,1.09-.22,1.48-.66s.58-1.05.58-1.82v-1.38c0-.77-.19-1.38-.58-1.82s-.88-.66-1.48-.66-1.08.22-1.47.66c-.39.44-.59,1.05-.59,1.82v1.38c0,.77.2,1.38.59,1.82.39.44.88.66,1.47.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m252.14,80.58v-15.64h1.39v15.64h-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m264.4,77.35c-.86,0-1.6-.19-2.22-.56s-1.09-.89-1.42-1.56c-.33-.66-.49-1.41-.49-2.25v-.29c0-.86.16-1.62.49-2.28.33-.66.8-1.17,1.42-1.54.62-.37,1.35-.55,2.2-.55s1.62.19,2.23.56c.62.37,1.09.89,1.42,1.55s.49,1.41.49,2.26v.29c0,.86-.17,1.62-.49,2.28s-.8,1.17-1.42,1.54c-.62.37-1.36.55-2.22.55Zm0-1.34c.6,0,1.09-.22,1.48-.66.38-.44.58-1.05.58-1.82v-1.38c0-.77-.19-1.38-.58-1.82-.39-.44-.88-.66-1.48-.66s-1.08.22-1.47.66-.59,1.05-.59,1.82v1.38c0,.77.2,1.38.59,1.82s.88.66,1.47.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m274.8,65.52c.87.99,1.54,2.1,2.01,3.33.46,1.24.7,2.52.7,3.84s-.23,2.58-.7,3.82c-.46,1.24-1.13,2.35-2.01,3.34h-1.09c.41-.66.77-1.38,1.09-2.17s.57-1.61.76-2.46c.19-.86.28-1.7.28-2.52s-.09-1.69-.27-2.54c-.18-.86-.43-1.68-.76-2.47s-.69-1.51-1.1-2.16h1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m286.36,65.52c.87.99,1.54,2.1,2.01,3.33.46,1.24.7,2.52.7,3.84s-.23,2.58-.7,3.82c-.46,1.24-1.13,2.35-2.01,3.34h-1.09c.41-.66.77-1.38,1.09-2.17.32-.79.57-1.61.76-2.46.19-.86.28-1.7.28-2.52s-.09-1.69-.27-2.54c-.18-.86-.43-1.68-.76-2.47-.32-.79-.69-1.51-1.1-2.16h1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m298.38,80.58v-15.64h1.39v15.64h-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m309.94,80.58v-15.64h1.39v15.64h-1.39Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m193.88,85.92c.87.99,1.54,2.1,2.01,3.33.46,1.24.7,2.52.7,3.84s-.23,2.58-.7,3.82c-.46,1.24-1.13,2.35-2.01,3.34h-1.09c.41-.66.77-1.38,1.09-2.17s.57-1.61.76-2.46c.19-.86.28-1.7.28-2.52s-.09-1.69-.27-2.54c-.18-.86-.43-1.68-.76-2.47-.32-.79-.69-1.51-1.1-2.16h1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m209.9,100.49l-8.16-14.57h1.55l8.18,14.57h-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m213.91,99.81v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m225.47,99.81v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m236.42,100.49l8.18-14.57h1.55l-8.16,14.57h-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m251.56,97.58l-3.64-11.66h2.11l2.86,9.74h.07l2.77-9.74h2.02l-3.62,11.66h-2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m267.7,100.49l-8.16-14.57h1.55l8.18,14.57h-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m271.71,99.81v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m283.27,99.81v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m294.22,100.49l8.18-14.57h1.55l-8.16,14.57h-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m311.8,100.25c-.87-.99-1.54-2.1-2.01-3.33-.46-1.23-.7-2.52-.7-3.84s.23-2.59.7-3.83c.46-1.23,1.13-2.35,2.01-3.33h1.09c-.4.65-.76,1.37-1.08,2.16-.32.79-.58,1.61-.76,2.46s-.28,1.69-.28,2.53.09,1.67.28,2.53c.19.86.44,1.69.76,2.48.32.79.68,1.51,1.09,2.16h-1.09Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m178.62,120.89l8.18-14.57h1.55l-8.16,14.57h-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m201.81,114.43v-1.51c.17-.19.39-.39.66-.59.27-.2.59-.38.95-.52s.75-.21,1.16-.21c.36,0,.71.06,1.04.17.33.11.65.24.97.39s.64.28.98.39c.33.11.69.17,1.06.17.41,0,.79-.07,1.15-.21s.68-.31.96-.52.5-.4.66-.59v1.51c-.16.19-.38.39-.66.59s-.6.38-.96.52-.74.21-1.15.21c-.36,0-.71-.06-1.04-.17s-.65-.24-.97-.39c-.32-.15-.64-.28-.98-.39-.33-.11-.69-.17-1.06-.17-.41,0-.79.07-1.16.21s-.68.31-.95.52c-.27.2-.49.4-.66.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m227.58,114.26v-1.77h4.3v1.77h-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m240.09,117.98v-2.26h2.38v2.26h-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m251.65,117.98v-2.26h2.38v2.26h-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m263.21,117.98v-2.26h2.38v2.26h-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m273.82,114.26v-1.77h4.3v1.77h-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m294.29,114.43v-1.51c.17-.19.39-.39.66-.59.27-.2.59-.38.95-.52s.75-.21,1.16-.21c.36,0,.71.06,1.04.17.33.11.65.24.97.39s.64.28.98.39c.33.11.69.17,1.06.17.41,0,.79-.07,1.15-.21s.68-.31.96-.52.5-.4.66-.59v1.51c-.16.19-.38.39-.66.59s-.6.38-.96.52-.74.21-1.15.21c-.36,0-.71-.06-1.04-.17s-.65-.24-.97-.39c-.32-.15-.64-.28-.98-.39-.33-.11-.69-.17-1.06-.17-.41,0-.79.07-1.16.21s-.68.31-.95.52c-.27.2-.49.4-.66.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m325.5,120.89l-8.16-14.57h1.55l8.18,14.57h-1.56Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m171.22,141.78v-15.64h1.39v15.64h-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m186.78,141.29l-8.16-14.57h1.55l8.18,14.57h-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m195.19,128.38l-1.77-2.86.02-.05h1.75l1.34,2.91h-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m213.37,134.83v-1.51c.17-.19.39-.39.66-.59.27-.2.59-.38.95-.52.36-.14.75-.21,1.16-.21.36,0,.71.06,1.04.17s.65.24.97.39c.32.15.64.28.98.39.33.11.69.17,1.06.17.41,0,.79-.07,1.15-.21.36-.14.68-.31.96-.52s.5-.4.66-.59v1.51c-.16.19-.38.39-.66.59s-.6.38-.96.52c-.36.14-.74.21-1.15.21-.36,0-.71-.06-1.04-.17-.33-.11-.65-.24-.97-.39-.32-.15-.64-.28-.98-.39s-.69-.17-1.06-.17c-.41,0-.79.07-1.16.21-.36.14-.68.31-.95.52-.27.2-.49.4-.66.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m228.53,138.38v-2.26h2.38v2.26h-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m248.05,134.83v-1.51c.17-.19.39-.39.66-.59.27-.2.59-.38.95-.52s.75-.21,1.16-.21c.36,0,.71.06,1.04.17.33.11.65.24.97.39s.64.28.98.39c.33.11.69.17,1.06.17.41,0,.79-.07,1.15-.21s.68-.31.96-.52.5-.4.66-.59v1.51c-.16.19-.38.39-.66.59s-.6.38-.96.52-.74.21-1.15.21c-.36,0-.71-.06-1.04-.17s-.65-.24-.97-.39c-.32-.15-.64-.28-.98-.39s-.69-.17-1.06-.17c-.41,0-.79.07-1.16.21s-.68.31-.95.52c-.27.2-.49.4-.66.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m274.77,138.38v-2.26h2.38v2.26h-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m282.72,134.83v-1.51c.17-.19.39-.39.66-.59.27-.2.59-.38.95-.52s.75-.21,1.16-.21c.36,0,.71.06,1.04.17.33.11.65.24.97.39s.64.28.98.39c.33.11.69.17,1.06.17.41,0,.79-.07,1.15-.21s.68-.31.96-.52.5-.4.66-.59v1.51c-.16.19-.38.39-.66.59s-.6.38-.96.52-.74.21-1.15.21c-.36,0-.71-.06-1.04-.17s-.65-.24-.97-.39c-.32-.15-.64-.28-.98-.39s-.69-.17-1.06-.17c-.41,0-.79.07-1.16.21s-.68.31-.95.52c-.27.2-.49.4-.66.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m310.79,128.38l-1.77-2.86.02-.05h1.75l1.34,2.91h-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m317.34,141.29l8.18-14.57h1.55l-8.16,14.57h-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m333.06,141.78v-15.64h1.39v15.64h-1.39Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m138.4,161.45c-.87-.99-1.54-2.1-2.01-3.33s-.7-2.52-.7-3.84.23-2.59.7-3.83,1.13-2.35,2.01-3.33h1.09c-.4.65-.76,1.37-1.08,2.16-.32.79-.58,1.62-.77,2.46s-.28,1.69-.28,2.53.09,1.67.28,2.53.44,1.69.76,2.48c.32.79.68,1.51,1.09,2.16h-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m147.64,147.12c.87.99,1.54,2.1,2.01,3.33s.7,2.52.7,3.84-.23,2.58-.7,3.82c-.46,1.24-1.13,2.35-2.01,3.34h-1.09c.41-.66.77-1.38,1.09-2.17.32-.79.57-1.61.76-2.47.19-.86.28-1.7.28-2.52s-.09-1.69-.27-2.54c-.18-.86-.43-1.68-.76-2.47s-.69-1.51-1.1-2.16h1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m171.22,162.18v-15.64h1.39v15.64h-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m195.19,148.78l-1.77-2.86.02-.05h1.75l1.34,2.91h-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m201.81,155.23v-1.51c.17-.19.39-.39.66-.59.27-.2.59-.38.95-.52s.75-.21,1.16-.21c.36,0,.71.06,1.04.17.33.11.65.24.97.39s.64.28.98.39c.33.11.69.17,1.06.17.41,0,.79-.07,1.15-.21s.68-.31.96-.52.5-.4.66-.59v1.51c-.16.19-.38.39-.66.59s-.6.38-.96.52-.74.21-1.15.21c-.36,0-.71-.06-1.04-.17s-.65-.24-.97-.39c-.32-.15-.64-.28-.98-.39-.33-.11-.69-.17-1.06-.17-.41,0-.79.07-1.16.21s-.68.31-.95.52c-.27.2-.49.4-.66.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m227.58,155.06v-1.77h4.3v1.77h-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m248.54,158.78l3.35-8.69h1.89l3.37,8.69h-1.63l-2.67-7.02-2.65,7.02h-1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m273.82,155.06v-1.77h4.3v1.77h-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m294.29,155.23v-1.51c.17-.19.39-.39.66-.59.27-.2.59-.38.95-.52s.75-.21,1.16-.21c.36,0,.71.06,1.04.17.33.11.65.24.97.39s.64.28.98.39c.33.11.69.17,1.06.17.41,0,.79-.07,1.15-.21s.68-.31.96-.52.5-.4.66-.59v1.51c-.16.19-.38.39-.66.59s-.6.38-.96.52-.74.21-1.15.21c-.36,0-.71-.06-1.04-.17s-.65-.24-.97-.39c-.32-.15-.64-.28-.98-.39-.33-.11-.69-.17-1.06-.17-.41,0-.79.07-1.16.21s-.68.31-.95.52c-.27.2-.49.4-.66.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m310.79,148.78l-1.77-2.86.02-.05h1.75l1.34,2.91h-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m333.06,162.18v-15.64h1.39v15.64h-1.39Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m92.16,181.85c-.87-.99-1.54-2.1-2.01-3.33-.46-1.24-.7-2.52-.7-3.84s.23-2.59.7-3.83c.46-1.24,1.13-2.35,2.01-3.33h1.09c-.4.65-.76,1.37-1.08,2.16-.32.79-.58,1.62-.77,2.46-.19.85-.28,1.69-.28,2.53s.09,1.67.28,2.53c.19.86.44,1.69.76,2.48s.68,1.51,1.09,2.16h-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m101.41,167.52c.87.99,1.54,2.1,2.01,3.33.46,1.24.7,2.52.7,3.84s-.23,2.58-.7,3.82c-.46,1.24-1.13,2.35-2.01,3.34h-1.09c.41-.66.77-1.38,1.09-2.17.32-.79.57-1.61.76-2.47.19-.86.28-1.7.28-2.52s-.09-1.69-.27-2.54-.43-1.68-.76-2.47c-.32-.79-.69-1.51-1.1-2.16h1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m120.82,182.09l8.18-14.57h1.55l-8.16,14.57h-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m132.38,182.09l8.18-14.57h1.55l-8.16,14.57h-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m171.22,182.58v-15.64h1.39v15.64h-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m193.85,172.75v-2.26h2.38v2.26h-2.38Zm.05,9.11v-.25c.35-.38.61-.78.77-1.19s.25-.82.25-1.24h-.95v-2.55h2.16v2.19c0,.56-.09,1.1-.28,1.62s-.46,1-.82,1.42h-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m229.35,172.28l-.46-2.26v-2.5h1.67v2.5l-.46,2.26h-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m263.21,172.75v-2.26h2.38v2.26h-2.38Zm0,6.43v-2.26h2.38v2.26h-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m297.89,179.18v-2.26h2.38v2.26h-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m333.06,182.58v-15.64h1.39v15.64h-1.39Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m80.6,202.25c-.87-.99-1.54-2.1-2.01-3.33s-.7-2.52-.7-3.84.23-2.59.7-3.83,1.13-2.35,2.01-3.33h1.09c-.4.65-.76,1.37-1.08,2.16s-.58,1.62-.76,2.46c-.19.85-.28,1.69-.28,2.53s.09,1.67.28,2.53c.19.86.44,1.69.76,2.48s.68,1.51,1.09,2.16h-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m89.85,187.92c.87.99,1.54,2.1,2.01,3.33s.7,2.52.7,3.84-.23,2.58-.7,3.82c-.46,1.24-1.13,2.35-2.01,3.34h-1.09c.41-.66.77-1.38,1.09-2.17.32-.79.57-1.61.76-2.47.19-.86.28-1.7.28-2.52s-.09-1.69-.27-2.54c-.18-.86-.43-1.68-.76-2.47-.32-.79-.69-1.51-1.1-2.16h1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m105.86,202.49l-8.16-14.57h1.55l8.18,14.57h-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m117.42,202.49l-8.16-14.57h1.55l8.18,14.57h-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m120.82,202.49l8.18-14.57h1.55l-8.16,14.57h-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m132.99,201.81v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m149.96,202.25c-.87-.99-1.54-2.1-2.01-3.33-.46-1.24-.7-2.52-.7-3.84s.23-2.59.7-3.83c.46-1.24,1.13-2.35,2.01-3.33h1.09c-.4.65-.76,1.37-1.08,2.16-.32.79-.58,1.62-.76,2.46s-.28,1.69-.28,2.53.09,1.67.28,2.53.44,1.69.76,2.48c.32.79.68,1.51,1.09,2.16h-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m159.21,187.92c.87.99,1.54,2.1,2.01,3.33s.7,2.52.7,3.84-.23,2.58-.7,3.82c-.46,1.24-1.13,2.35-2.01,3.34h-1.09c.41-.66.77-1.38,1.09-2.17.32-.79.57-1.61.76-2.47.19-.86.28-1.7.28-2.52s-.09-1.69-.27-2.54c-.18-.86-.43-1.68-.76-2.47-.32-.79-.69-1.51-1.1-2.16h1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m186.78,202.49l-8.16-14.57h1.55l8.18,14.57h-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m205.41,199.58v-2.26h2.38v2.26h-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m228.53,193.15v-2.26h2.38v2.26h-2.38Zm0,6.43v-2.26h2.38v2.26h-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m252.46,192.68l-.46-2.26v-2.5h1.67v2.5l-.46,2.26h-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m286.33,193.15v-2.26h2.38v2.26h-2.38Zm.05,9.11v-.25c.35-.38.61-.78.77-1.19s.25-.82.25-1.24h-.95v-2.55h2.16v2.19c0,.56-.09,1.1-.28,1.62-.19.53-.46,1-.82,1.42h-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m310.26,192.68l-.46-2.26v-2.5h1.67v2.5l-.46,2.26h-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m317.34,202.49l8.18-14.57h1.55l-8.16,14.57h-1.56Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m63.63,222.21v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m75.19,222.21v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m86.75,222.21v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m97.7,222.89l8.18-14.57h1.55l-8.16,14.57h-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m120.82,222.89l8.18-14.57h1.55l-8.16,14.57h-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m132.99,222.21v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m144.55,222.21v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m156.11,222.21v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m167.67,222.21v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m179.23,222.21v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m194.67,213.08l-.46-2.26v-2.5h1.67v2.5l-.46,2.26h-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m205.41,219.98v-2.26h2.38v2.26h-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m251.65,213.55v-2.26h2.38v2.26h-2.38Zm.05,9.11v-.25c.35-.38.61-.78.77-1.19s.25-.82.25-1.24h-.95v-2.55h2.16v2.19c0,.56-.09,1.1-.28,1.62-.19.53-.46,1-.82,1.42h-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m275.59,213.08l-.46-2.26v-2.5h1.67v2.5l-.46,2.26h-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m297.89,219.98v-2.26h2.38v2.26h-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m310.26,213.08l-.46-2.26v-2.5h1.67v2.5l-.46,2.26h-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m317.95,222.21v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m329.51,222.21v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m341.07,222.21v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m352.63,222.21v-1.29h8.5v1.29h-8.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m132.99,242.61v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m179.18,240.38l3.35-8.69h1.89l3.37,8.69h-1.63l-2.67-7.02-2.65,7.02h-1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m206.75,230.38l-1.77-2.86.02-.05h1.75l1.34,2.91h-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m217.31,240.55c-.93,0-1.67-.26-2.23-.77s-.83-1.29-.83-2.32v-5.76h1.99v5.41c0,.66.16,1.15.47,1.47.31.32.73.48,1.27.48.36,0,.69-.09.97-.26.28-.17.5-.42.66-.73.16-.31.24-.66.24-1.05v-5.32h1.97v6.99c0,.18.04.31.12.39.08.08.19.12.34.12.1,0,.21-.01.31-.03.11-.02.22-.07.33-.15v1.22c-.15.1-.34.18-.59.24-.24.06-.48.08-.72.08-.42,0-.74-.06-.96-.17s-.37-.27-.45-.48c-.08-.2-.14-.44-.17-.7-.16.28-.36.52-.61.72-.25.2-.55.35-.9.46-.35.11-.75.16-1.21.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m228.87,240.55c-.93,0-1.67-.26-2.23-.77s-.83-1.29-.83-2.32v-5.76h1.99v5.41c0,.66.16,1.15.47,1.47.31.32.73.48,1.27.48.36,0,.69-.09.97-.26.28-.17.5-.42.66-.73.16-.31.24-.66.24-1.05v-5.32h1.97v6.99c0,.18.04.31.12.39.08.08.19.12.34.12.1,0,.21-.01.31-.03s.22-.07.33-.15v1.22c-.15.1-.34.18-.59.24-.24.06-.48.08-.72.08-.42,0-.74-.06-.96-.17-.22-.11-.37-.27-.45-.48-.08-.2-.14-.44-.17-.7-.16.28-.36.52-.61.72s-.55.35-.9.46-.75.16-1.21.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m239.14,236.66v-1.77h4.3v1.77h-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m250.7,236.66v-1.77h4.3v1.77h-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m262.26,236.66v-1.77h4.3v1.77h-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m275.11,240.55c-.93,0-1.67-.26-2.23-.77s-.83-1.29-.83-2.32v-5.76h1.99v5.41c0,.66.16,1.15.47,1.47.31.32.73.48,1.27.48.36,0,.69-.09.97-.26.28-.17.5-.42.66-.73.16-.31.24-.66.24-1.05v-5.32h1.97v6.99c0,.18.04.31.12.39.08.08.19.12.34.12.1,0,.21-.01.31-.03.11-.02.22-.07.33-.15v1.22c-.15.1-.34.18-.59.24-.24.06-.48.08-.72.08-.42,0-.74-.06-.96-.17s-.37-.27-.45-.48c-.08-.2-.14-.44-.17-.7-.16.28-.36.52-.61.72-.25.2-.55.35-.9.46-.35.11-.75.16-1.21.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m286.67,240.55c-.93,0-1.67-.26-2.23-.77-.55-.52-.83-1.29-.83-2.32v-5.76h1.99v5.41c0,.66.16,1.15.47,1.47s.73.48,1.27.48c.36,0,.69-.09.97-.26.28-.17.5-.42.66-.73s.24-.66.24-1.05v-5.32h1.97v6.99c0,.18.04.31.12.39.08.08.19.12.34.12.1,0,.21-.01.31-.03s.22-.07.33-.15v1.22c-.15.1-.34.18-.59.24s-.48.08-.72.08c-.42,0-.74-.06-.96-.17s-.37-.27-.45-.48c-.08-.2-.14-.44-.17-.7-.16.28-.36.52-.61.72-.25.2-.55.35-.9.46-.35.11-.75.16-1.21.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m299.23,230.38l-1.77-2.86.02-.05h1.75l1.34,2.91h-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m352.02,243.29l8.18-14.57h1.55l-8.16,14.57h-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m371.74,243.29l-8.16-14.57h1.55l8.18,14.57h-1.56Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m52.07,263.01v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m63.63,263.01v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m78.05,263.94c-.41,0-.8-.05-1.18-.14-.38-.09-.7-.21-.96-.36v-1.34c.19.1.44.2.73.28s.59.13.88.13c.25,0,.48-.03.7-.09s.39-.2.53-.42c.14-.21.21-.54.21-.97v-7.43h-3.04v-1.51h5.01v8.96c0,.97-.26,1.7-.79,2.18-.53.48-1.22.71-2.08.71Zm.93-13.62v-1.75h1.77v1.75h-1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m89,263.98c-.76,0-1.34-.2-1.73-.6-.4-.4-.6-.88-.6-1.46,0-.43.12-.82.36-1.16.24-.34.54-.59.92-.75-.25-.16-.45-.37-.59-.63-.14-.26-.21-.54-.21-.83,0-.41.13-.77.4-1.09.27-.32.63-.52,1.08-.59-.41-.24-.72-.54-.93-.92-.21-.37-.31-.8-.31-1.29,0-.84.31-1.5.92-2,.61-.49,1.54-.74,2.77-.74.68,0,1.23.08,1.65.26.46-.12.8-.33,1.02-.63.21-.29.34-.63.37-1.02h1.56c0,.59-.16,1.07-.48,1.45-.32.38-.75.63-1.28.76v.03c.27.21.48.49.63.82.15.33.22.69.22,1.06,0,.84-.28,1.51-.85,2.01s-1.4.76-2.5.76h-1.39c-.32,0-.57.07-.76.21s-.28.34-.28.6.09.46.27.6.43.21.75.21h3.01c.84,0,1.49.21,1.96.64.47.42.71.99.71,1.69,0,.76-.23,1.38-.71,1.86-.47.48-1.14.72-2,.72h-3.98Zm.56-1.22h3.11c.38,0,.68-.1.88-.31.21-.21.31-.47.31-.77s-.1-.54-.3-.75c-.2-.2-.5-.31-.89-.31h-3.11c-.39,0-.68.1-.88.31s-.3.46-.3.76.1.53.3.75c.2.21.49.32.88.32Zm1.55-6.53c.57,0,1.01-.13,1.34-.4.33-.27.49-.65.49-1.15s-.16-.88-.49-1.14-.78-.39-1.34-.39-1.01.13-1.34.39c-.33.26-.49.64-.49,1.14s.16.88.49,1.15c.33.27.78.4,1.34.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m102.41,260.95c-.72,0-1.37-.1-1.93-.3-.56-.2-1-.49-1.32-.87-.32-.38-.48-.84-.48-1.39v-.14c0-.06,0-.13.02-.21h1.68v.15c0,.44.19.79.58,1.04.39.25.94.37,1.67.37.67,0,1.17-.11,1.5-.33.33-.22.49-.51.49-.88,0-.24-.07-.43-.21-.59-.14-.15-.39-.29-.76-.4s-.92-.23-1.65-.34c-.75-.12-1.35-.29-1.82-.49s-.8-.47-1.01-.8c-.21-.33-.31-.74-.31-1.24,0-.59.16-1.08.48-1.46.32-.38.76-.67,1.33-.87.57-.19,1.22-.29,1.97-.29.66,0,1.25.1,1.78.29.53.19.95.46,1.27.81.32.35.48.76.48,1.25v.13c0,.05-.01.12-.03.2h-1.7c0-.36-.08-.64-.25-.83-.17-.19-.4-.33-.69-.4-.29-.07-.62-.11-.98-.11-1.22,0-1.84.37-1.84,1.11,0,.2.07.37.2.5.13.13.37.25.72.35.35.1.86.22,1.53.34.82.14,1.47.31,1.96.52.49.21.84.48,1.05.83.22.34.32.78.32,1.33,0,.63-.16,1.15-.48,1.56-.32.4-.79.7-1.39.89s-1.32.29-2.16.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m109.87,263.01v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m121.43,263.01v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m132.99,263.01v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m144.55,263.01v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m156.11,263.01v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m167.67,263.01v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m179.23,263.01v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m190.79,263.01v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m202.3,260.78l3.35-8.69h1.89l3.37,8.69h-1.63l-2.67-7.02-2.65,7.02h-1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m225.47,263.01v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m237.03,263.01v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m248.59,263.01v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m260.15,263.01v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m271.71,263.01v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m283.27,263.01v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m294.83,263.01v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m306.39,263.01v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m317.95,263.01v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m329.46,260.78l3.35-8.69h1.89l3.37,8.69h-1.63l-2.67-7.02-2.65,7.02h-1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m341.07,263.01v-1.29h8.5v1.29h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m360.18,263.69l-8.16-14.57h1.55l8.18,14.57h-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m363.58,263.69l8.18-14.57h1.55l-8.16,14.57h-1.56Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m209.9,284.09l-8.16-14.57h1.55l8.18,14.57h-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m233.02,284.09l-8.16-14.57h1.55l8.18,14.57h-1.56Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m201.74,304.49l8.18-14.57h1.55l-8.16,14.57h-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m213.3,304.49l8.18-14.57h1.55l-8.16,14.57h-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m233.02,304.49l-8.16-14.57h1.55l8.18,14.57h-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m244.58,304.49l-8.16-14.57h1.55l8.18,14.57h-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m254,304.25c-.87-.99-1.54-2.1-2.01-3.33-.46-1.24-.7-2.52-.7-3.84s.23-2.59.7-3.82c.46-1.24,1.13-2.35,2.01-3.33h1.09c-.4.65-.76,1.37-1.08,2.16-.32.79-.58,1.62-.77,2.46-.19.85-.28,1.69-.28,2.53s.09,1.67.28,2.53c.19.86.44,1.69.76,2.48s.68,1.51,1.09,2.16h-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m263.24,289.92c.87.99,1.54,2.1,2.01,3.33.46,1.23.7,2.52.7,3.84s-.23,2.58-.7,3.82c-.46,1.24-1.13,2.35-2.01,3.34h-1.09c.41-.66.77-1.38,1.09-2.17.32-.79.57-1.61.76-2.47.19-.86.28-1.7.28-2.52s-.09-1.69-.27-2.54c-.18-.85-.43-1.68-.76-2.47-.32-.79-.69-1.51-1.1-2.16h1.09Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m184.64,324.65c-.87-.99-1.54-2.1-2.01-3.33-.46-1.24-.7-2.52-.7-3.84s.23-2.59.7-3.83c.46-1.24,1.13-2.35,2.01-3.33h1.09c-.4.65-.76,1.37-1.08,2.16-.32.79-.58,1.62-.76,2.46s-.28,1.69-.28,2.53.09,1.67.28,2.53.44,1.69.76,2.48c.32.79.68,1.51,1.09,2.16h-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m193.88,310.32c.87.99,1.54,2.1,2.01,3.33.46,1.24.7,2.52.7,3.84s-.23,2.58-.7,3.82c-.46,1.24-1.13,2.35-2.01,3.34h-1.09c.41-.66.77-1.38,1.09-2.17.32-.79.57-1.61.76-2.47.19-.86.28-1.7.28-2.52s-.09-1.69-.27-2.54-.43-1.68-.76-2.47c-.32-.79-.69-1.51-1.1-2.16h1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m201.74,324.89l8.18-14.57h1.55l-8.16,14.57h-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m242.44,324.65c-.87-.99-1.54-2.1-2.01-3.33s-.7-2.52-.7-3.84.23-2.59.7-3.83,1.13-2.35,2.01-3.33h1.09c-.4.65-.76,1.37-1.08,2.16s-.58,1.62-.76,2.46c-.19.85-.28,1.69-.28,2.53s.09,1.67.28,2.53c.19.86.44,1.69.76,2.48s.68,1.51,1.09,2.16h-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m251.68,310.32c.87.99,1.54,2.1,2.01,3.33s.7,2.52.7,3.84-.23,2.58-.7,3.82c-.46,1.24-1.13,2.35-2.01,3.34h-1.09c.41-.66.77-1.38,1.09-2.17.32-.79.57-1.61.76-2.47.19-.86.28-1.7.28-2.52s-.09-1.69-.27-2.54c-.18-.86-.43-1.68-.76-2.47-.32-.79-.69-1.51-1.1-2.16h1.09Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m196.2,345.05c-.87-.99-1.54-2.1-2.01-3.33s-.7-2.52-.7-3.84.23-2.59.7-3.83,1.13-2.35,2.01-3.33h1.09c-.4.65-.76,1.37-1.08,2.16-.32.79-.58,1.62-.77,2.46s-.28,1.69-.28,2.53.09,1.67.28,2.53.44,1.69.76,2.48c.32.79.68,1.51,1.09,2.16h-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m205.44,330.72c.87.99,1.54,2.1,2.01,3.33.46,1.24.7,2.52.7,3.84s-.23,2.58-.7,3.82c-.46,1.24-1.13,2.35-2.01,3.34h-1.09c.41-.66.77-1.38,1.09-2.17.32-.79.57-1.61.76-2.47.19-.86.28-1.7.28-2.52s-.09-1.69-.27-2.54-.43-1.68-.76-2.47c-.32-.79-.69-1.51-1.1-2.16h1.09Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m167.58,479.01c.36.56.67,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.91.41-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.4-1.08-.99-2.05-1.75-2.91h-.95Zm-21.03,10.99h-7.42v1.13h7.42v-1.13Zm-10.65,1.51c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.25-1.49-.25-2.21s.08-1.47.25-2.21c.16-.74.38-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.4,1.08-.61,2.19-.61,3.34s.2,2.28.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m158.68,461.21c.36.56.67,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.34-1.83,1.75-2.91.4-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-6.62,4.15l.4-1.97v-2.18h-1.45v2.18l.4,1.97h.65Zm-8.19,4.05h-2.08v1.97h2.08v-1.97Zm-98.61-4.05l.4-1.97v-2.18h-1.45v2.18l.4,1.97h.65Zm-8.19,4.05h-2.08v1.97h2.08v-1.97Zm-6.23,2.79h-7.42v1.13h7.42v-1.13Zm-10.65,1.51c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.27.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m258.87,447.56l.4-1.97v-2.18h-1.45v2.18l.4,1.97h.65Zm-8.19,4.05h-2.08v1.97h2.08v-1.97Zm-6.23,2.79h-7.42v1.13h7.42v-1.13Zm-8.9,0h-7.42v1.13h7.42v-1.13Zm-19.62-5.61h-3.75v1.54h3.75v-1.54Zm-9.48-3.93l-1.17-2.54h-1.53l-.02.04,1.54,2.49h1.17Zm-72.18,2.7l.4-1.97v-2.18h-1.45v2.18l.4,1.97h.65Zm-7.34,1.23h-3.75v1.54h3.75v-1.54Zm-8.9,0h-3.75v1.54h3.75v-1.54Zm-75.04-5.39c.36.56.67,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15s-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.92.4-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-13.88,12.51c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.27.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m367.23,430.99h-3.75v1.54h3.75v-1.54Zm-9.75,2.82h-2.08v1.97h2.08v-1.97Zm-9.61-4.05l.4-1.97v-2.18h-1.45v2.18l.4,1.97h.65Zm-7.34,1.23h-3.75v1.54h3.75v-1.54Zm-9.48-3.93l-1.17-2.54h-1.53l-.02.05,1.54,2.49h1.17Zm-56.66-1.45c.36.56.67,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.34-1.83,1.75-2.91.4-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-8.9,0c.36.56.67,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.91s.61-2.19.61-3.33-.2-2.27-.61-3.35c-.4-1.08-.99-2.05-1.75-2.91h-.95Zm-31.68,12.51c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.25-1.49-.25-2.21s.08-1.47.25-2.21c.16-.74.39-1.46.67-2.15.28-.69.59-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.28.61,3.35c.4,1.08.99,2.05,1.75,2.91h.95Zm-35.6,0c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.34,1.83-1.75,2.91-.4,1.08-.61,2.19-.61,3.34s.2,2.28.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Zm-57.32-12.51c.36.56.68,1.19.96,1.88s.5,1.41.66,2.16c.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.91.4-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-33.32,4.15l.4-1.97v-2.18h-1.45v2.18l.4,1.97h.65Zm-8.19-1.56h-2.08v1.97h2.08v-1.97Zm0,5.61h-2.08v1.97h2.08v-1.97Zm-8.9,0h-2.08v1.97h2.08v-1.97Zm-6.23,2.79h-7.42v1.13h7.42v-1.13Zm-8.9,0h-7.42v1.13h7.42v-1.13Zm-20.2-9.54l-1.17-2.54h-1.53v.05s1.53,2.49,1.53,2.49h1.17Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m354.48,407.81c.36.56.67,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.25,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.34-1.83,1.75-2.92.41-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-31.68,12.51c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.25-1.49-.25-2.21s.08-1.47.25-2.21c.16-.74.38-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.4,1.08-.61,2.19-.61,3.34s.2,2.28.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Zm-57.32-12.51c.36.56.67,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.34-1.83,1.75-2.92.4-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-23.7,8.2h-2.08v1.97h2.08v-1.97Zm-34.68,4.3c-.36-.56-.67-1.19-.95-1.88s-.5-1.41-.66-2.17c-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.28.61,3.35c.4,1.08.99,2.05,1.75,2.91h.95Zm-75.12-12.51c.36.56.67,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.92.4-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-17.8,0c.36.56.68,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.34-1.83,1.75-2.92.4-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-67.28,12.51c-.36-.56-.67-1.19-.95-1.88s-.5-1.41-.66-2.17c-.16-.75-.25-1.49-.25-2.21s.08-1.47.25-2.21c.16-.74.39-1.46.67-2.15s.6-1.32.94-1.88h-.95c-.76.86-1.34,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.28.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Zm-9.55-11.05l-1.17-2.54h-1.53v.05s1.53,2.49,1.53,2.49h1.17Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m363.38,390.01c.36.56.68,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.92.4-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-17.8,0c.36.56.67,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.92.4-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-23.44,1.45l-1.17-2.54h-1.53l-.02.04,1.54,2.49h1.17Zm-6.5,9.54h-7.42v1.13h7.42v-1.13Zm-20.2-9.54l-1.17-2.54h-1.53v.04s1.53,2.49,1.53,2.49h1.17Zm-38.86-1.45c.36.56.67,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.92.41-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.4-1.08-.99-2.05-1.75-2.91h-.95Zm-31.68,12.5c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.4,1.08-.61,2.19-.61,3.34s.2,2.28.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Zm-10.18-2.33v-3.13h3.11v-1.32h-3.11v-3.13h-1.36v3.13h-3.11v1.32h3.11v3.13h1.36Zm-8.54-1.97h-2.08v1.97h2.08v-1.97Zm-36.31-4.05l.4-1.97v-2.18h-1.45v2.18l.4,1.97h.65Zm-7.34,1.23h-3.75v1.54h3.75v-1.54Zm-10.46-1.23l.4-1.97v-2.18h-1.45v2.18l.4,1.97h.65Zm-8.19-1.56h-2.08v1.97h2.08v-1.97Zm0,5.61h-2.08v1.97h2.08v-1.97Zm-8.9,0h-2.08v1.97h2.08v-1.97Zm-6.23,2.79h-7.42v1.13h7.42v-1.13Zm-8.9,0h-7.42v1.13h7.42v-1.13Zm-11.57-2.79h-2.08v1.97h2.08v-1.97Zm-8.9,0h-2.08v1.97h2.08v-1.97Zm-7.98,4.3c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.25-1.49-.25-2.21s.08-1.47.25-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.28.61,3.35c.4,1.08.99,2.05,1.75,2.91h.95Zm-44.5,0c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.25-1.49-.25-2.21s.08-1.47.25-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.4,1.08-.61,2.19-.61,3.34s.2,2.28.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Zm-8.9,0c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.28.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m372.28,372.21c.36.56.68,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.92.41-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.4-1.08-.99-2.05-1.75-2.91h-.95Zm-17.8,0c.36.56.67,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.92.41-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.4-1.08-.99-2.05-1.75-2.91h-.95Zm-40.58,12.5c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.4,1.08-.61,2.19-.61,3.34s.2,2.27.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Zm-27.62-4.3h-2.08v1.97h2.08v-1.97Zm-8.63-6.75l-1.17-2.54h-1.53l-.02.04,1.54,2.49h1.17Zm-26.12,3.93h-3.75v1.54h3.75v-1.54Zm-8.9,0h-3.75v1.54h3.75v-1.54Zm-9.75,2.82h-2.08v1.97h2.08v-1.97Zm-56.4-8.2c.36.56.67,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.92.41-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.4-1.08-.99-2.05-1.75-2.91h-.95Zm-32.6,8.2h-2.08v1.97h2.08v-1.97Zm-61.38,4.3c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.25-1.49-.25-2.21s.08-1.47.25-2.21c.16-.74.38-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.4,1.08-.61,2.19-.61,3.34s.2,2.27.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Zm-9.55-11.05l-1.17-2.54h-1.53v.04s1.53,2.49,1.53,2.49h1.17Zm-8.25,11.05c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.25-1.49-.25-2.21s.08-1.47.25-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.27.61,3.35c.4,1.08.99,2.05,1.75,2.91h.95Zm-7.06-5.18h-7.6v1.32h7.6v-1.32Zm0-3.16h-7.6v1.32h7.6v-1.32Zm-11.66,4.04h-2.08v1.97h2.08v-1.97Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m363.38,354.41c.36.56.67,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.25,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.34-1.83,1.75-2.92.41-1.08.61-2.19.61-3.33s-.2-2.28-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-41.5,8.2h-2.08v1.97h2.08v-1.97Zm-34.68,4.3c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.25-1.49-.25-2.21s.08-1.47.25-2.21c.16-.74.38-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.4,1.08-.61,2.19-.61,3.34s.2,2.27.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Zm-9.82-9.91h-2.08v1.97h2.08v-1.97Zm0,5.61h-2.08v1.97h2.08v-1.97Zm-97.9,0h-2.08v1.97h2.08v-1.97Zm-8.63-6.75l-1.17-2.54h-1.53v.04s1.53,2.49,1.53,2.49h1.17Zm-9.88,2.7l.4-1.97v-2.18h-1.45v2.18l.4,1.97h.65Zm-69.57,8.35c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.38-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.4,1.08-.61,2.19-.61,3.34s.2,2.27.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Zm-7.15-1.51h-7.42v1.13h7.42v-1.13Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m357.48,344.81h-2.08v1.97h2.08v-1.97Zm-8.63-6.75l-1.17-2.54h-1.53v.04s1.53,2.49,1.53,2.49h1.17Zm-12.16-1.45c.36.56.67,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.91.41-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.4-1.08-.99-2.05-1.75-2.91h-.95Zm-23.44,1.45l-1.17-2.54h-1.53v.04s1.53,2.49,1.53,2.49h1.17Zm-8.25,11.05c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.34,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.27.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Zm-9.82-9.91h-2.08v1.97h2.08v-1.97Zm0,5.61h-2.08v1.97h2.08v-1.97Zm-8.9,0h-2.08v1.97h2.08v-1.97Zm-133.5,0h-2.08v1.97h2.08v-1.97Zm-11.9-8.2c.36.56.67,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.91.41-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.4-1.08-.99-2.05-1.75-2.91h-.95Zm-49.48,12.51c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.25-1.49-.25-2.21s.08-1.47.25-2.21c.16-.74.38-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.4,1.08-.61,2.19-.61,3.34s.2,2.27.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m324.55,329.8h-7.42v1.13h7.42v-1.13Zm-180.67-2.79h-2.08v1.97h2.08v-1.97Zm-11.9-8.2c.36.56.68,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.91.41-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.4-1.08-.99-2.05-1.75-2.91h-.95Zm-23.44,1.45l-1.17-2.54h-1.53v.04s1.53,2.49,1.53,2.49h1.17Zm-8.25,11.05c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.25-1.49-.25-2.21s.08-1.47.25-2.21c.16-.74.38-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.4,1.08-.61,2.19-.61,3.34s.2,2.27.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 121.33,
    y: 312,
    width: 7.42,
    height: 1.13
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeslimat);
export default __webpack_public_path__ + "static/media/teslimat.c3f5ded9d40b294010f18190eec81248.svg";
export { ForwardRef as ReactComponent };